import { render, staticRenderFns } from "./MaterialStandardMappingList.vue?vue&type=template&id=55eb9b28&scoped=true&"
import script from "./MaterialStandardMappingList.vue?vue&type=script&lang=js&"
export * from "./MaterialStandardMappingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eb9b28",
  null
  
)

export default component.exports